const SDK_VERSION = '7.98.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
